<template>
  <UserCreateEditForm />
</template>
